import { createReducer } from './Reducer';
export const avg = createReducer((average, nextValue, count) => {
    return (nextValue + count * average) / (count + 1);
});
